module.exports = __webpack_public_path__ + "static/img/palyer.97ad94c1.png";